import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from './ErrorBoundary';
import { localizeNativeDialogs, startGlobalArabicLocalization } from './lib/localization';

startGlobalArabicLocalization();
localizeNativeDialogs();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

window.addEventListener('error', (event) => {
  // Suppress known benign environment errors
  if (event.message?.includes('WebSocket closed without opened') || event.message?.includes('failed to connect to websocket')) {
    event.preventDefault();
    return;
  }

  document.body.innerHTML += `<div style="position:fixed;top:0;left:0;z-index:9999;background:red;color:white;padding:20px;font-family:monospace;width:100%;max-height:100vh;overflow:auto;">
    <h2>${document.documentElement.lang === 'ar' ? 'خطأ غير متوقع!' : 'Uncaught Error!'}</h2>
    <p>${event.message}</p>
    <pre>${event.error?.stack}</pre>
  </div>`;
});

window.addEventListener('unhandledrejection', (event) => {
  // Suppress known benign environment errors
  const reason = String(event.reason);
  if (
    reason.toLowerCase().includes('websocket') || 
    reason.toLowerCase().includes('failed to connect') ||
    reason.toLowerCase().includes('closed without opened')
  ) {
    event.preventDefault();
    return;
  }

  document.body.innerHTML += `<div style="position:fixed;top:0;left:0;z-index:9999;background:orange;color:white;padding:20px;font-family:monospace;width:100%;max-height:100vh;overflow:auto;">
    <h2>${document.documentElement.lang === 'ar' ? 'رفض غير معالج لوعد برمجي!' : 'Unhandled Promise Rejection!'}</h2>
    <p>${event.reason}</p>
    <pre>${event.reason?.stack}</pre>
  </div>`;
});
